import * as React from 'react';
import Stack from '@mui/material/Stack';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export default function Notifiy({ openNotify, variant, message, onClose }) {
    const [open, setOpen] = React.useState(openNotify);

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        onClose((prev) => ({ ...prev, show: false }));
        setOpen(false);
    };

    return (
        <Stack spacing={2} sx={{ width: '100%' }}>
            <Snackbar
                open={open}
                autoHideDuration={2000}
                onClose={handleClose}
                anchorOrigin={{ vertical: 'top', horizontal: 'center', }}
            >
                <Alert onClose={handleClose} severity={variant || 'info'} sx={{ width: '100%' }}>
                    {message}
                </Alert>
            </Snackbar>
        </Stack>
    );
}